import React from 'react'
import { useSelector } from 'react-redux'
import { selectBrandName } from 'src/redux/selectors/session.selectors'

interface BrandMarkLogoProps {
  className?: string
  knockout?: boolean
}

const BrandMarkLogo: React.FC<BrandMarkLogoProps> = (props) => {
  const brandName = useSelector(selectBrandName)
  return (
    <img
      className={props.className}
      src={`https://brand-assets.paywithextend.com/${brandName}/MarkLogo${props.knockout ? 'Knockout' : ''}.svg`}
      alt={''}
    />
  )
}

export default BrandMarkLogo
